module.exports = __webpack_public_path__ + "static/media/27.aa0cf37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/27.png
// module id = 1133
// module chunks = 0